import React, { useState, useEffect, useRef } from 'react';
import ProfileFormModal from './ProfileFormModal';

// Icons remain the same
const CloseIcon = ({ size = 20, className = '' }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
);
const EyeIcon = ({ size = 16, className = '' }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        <circle cx="12" cy="12" r="3"></circle>
    </svg>
);
const EyeSlashIcon = ({ size = 16, className = '' }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.54 18.54 0 0 1 5.05-4.84m1.48-1.48A10.07 10.07 0 0 1 12 4c7 0 11 8 11 8a18.54 18.54 0 0 1-2.9 3.99m-1.39-1.39A3 3 0 0 0 12 10a3 3 0 0 0-1.07.18"></path>
        <line x1="1" y1="1" x2="23" y2="23"></line>
    </svg>
);
const MaximizeIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
  </svg>
);
const MinimizeIcon = ({ size = 20, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
  </svg>
);
const PlusIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);
const SearchIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  </svg>
);
const EditIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);
const TrashIcon = ({ size = 16, className = '' }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
);
const SaveIcon = ({ size = 16, className = '' }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
        <polyline points="17 21 17 13 7 13 7 21"></polyline>
        <polyline points="7 3 7 8 15 8"></polyline>
    </svg>
);

const API_URL = '/api';

const initialFields = {
    Username: '',
    FullName: '',
    Email: '',
    Phone: '',
    Role: 'User',
    IsActive: 1,
    Password: '',
    department_id: '',
    screen_config: '',
    ProfileID: ''
};

const UserFormModal = ({ open, onClose, onSubmit, initialData, isEdit, loading }) => {
    const [fields, setFields] = useState(initialFields);
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSavingPermissions, setIsSavingPermissions] = useState(false);
    const [activeTab, setActiveTab] = useState('userInfo');
    const [currentUser, setCurrentUser] = useState(null);
    const [isUserValid, setIsUserValid] = useState(false);
    const [authError, setAuthError] = useState(null);
    const [isMaximized, setIsMaximized] = useState(false);
    
    // Department-related state
    const [departments, setDepartments] = useState([]);
    const [loadingDepartments, setLoadingDepartments] = useState(false);
    const [screenConfig, setScreenConfig] = useState(null);
    const [showDepartmentField, setShowDepartmentField] = useState(false);
    
    // Profile-related state
    const [profiles, setProfiles] = useState([]);
    const [loadingProfiles, setLoadingProfiles] = useState(false);
    const [showProfileField, setShowProfileField] = useState(false);
    const [profilesFetched, setProfilesFetched] = useState(false);
    
    // Screens state
    const [screens, setScreens] = useState([]);
    
    // --- PERMISSION STATE ---
    const [permissionScreenList, setPermissionScreenList] = useState([]);
    const [loadingPermissions, setLoadingPermissions] = useState(false);
    const [permissionTabActive, setPermissionTabActive] = useState(false);
    const [profileDefaults, setProfileDefaults] = useState([]); 
    const [permissionSearchTerm, setPermissionSearchTerm] = useState('');
    // --------------------------

    // Profile dropdown state
    const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
    const [profileSearchTerm, setProfileSearchTerm] = useState('');
    const [showCreateProfileModal, setShowCreateProfileModal] = useState(false);
    const [editingProfile, setEditingProfile] = useState(null);

   //filter
    const [screenFilters, setScreenFilters] = useState([]); // Stores { ScreenID, ScreenName, Values: [] }
    const [filterOptions, setFilterOptions] = useState({}); // Stores fetched data for dropdowns
    const [activeFilterDropdown, setActiveFilterDropdown] = useState(null); // Index of the open dropdown
    const [filterSearchTerm, setFilterSearchTerm] = useState(''); // Search term inside dropdown
    const [focusedOptionIndex, setFocusedOptionIndex] = useState(-1);

     // Configuration for Filter Screens
    const FILTER_CONFIG = {
        'ProjectList': { endpoint: '/project', key: 'No', labelField1: 'No', labelField2: 'Description' },
        'Feeder': { endpoint: '/feeder', key: 'Code', labelField1: 'Code', labelField2: 'Description' },
        'WAREHOUSE': { endpoint: '/locations', key: 'LocationCode', labelField1: 'LocationCode', labelField2: 'LocationName' },
        'Branch': { endpoint: '/branches', key: 'BranchCode', labelField1: 'BranchCode', labelField2: 'BranchName' }
    };
    
    const fileInputRefs = useRef({});
    const profileDropdownRef = useRef(null);
    const filterDropdownRef = useRef(null);

       const getAuthHeaders = (isFormData = false) => {
      const token = localStorage.getItem('authToken');
      
      const headers = {
        // Only add Authorization if token exists
        ...(token && { 'Authorization': `Bearer ${token}` })
      };
  
      // Only set Content-Type to 'application/json' if we are NOT sending FormData.
      // (This handles JSON requests automatically, and leaves FormData to the browser)
      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }
  
      return headers;
    };
    
    // --- PERMISSION FETCHING LOGIC ---

    // 1. Fetch User Overrides (Existing)
    const fetchUserOverrides = async (userId) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return [];
            
            const response = await fetch(`${API_URL}/user/${userId}/permissions`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                return data.permissions || [];
            }
        } catch (error) {
            console.error('Error fetching user overrides:', error);
        }
        return [];
    };

    // 2. NEW: Fetch Profile Defaults (From ProfilePermissions table)
    // This follows the exact same pattern as fetchScreens and fetchProfiles
    const fetchProfilePermissions = async (profileID) => {
        if (!profileID) return [];
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return [];
            
            // Endpoint structure matches your fetch pattern: /table-name/id
            const response = await fetch(`${API_URL}/profile-permissions/${profileID}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            
            if (response.ok) {
                const data = await response.json();
                // Adjust based on your actual API response structure
                // It might return { permissions: [...] } or just [...]
                return data.permissions || data || [];
            }
        } catch (error) {
            console.error('Error fetching profile permissions:', error);
        }
        return [];
    };

    // 3. Updated Load Logic
    const loadPermissionsForUI = async () => {
        if (!fields.ProfileID) {
            setPermissionScreenList([]);
            setProfileDefaults([]);
            return;
        }
        
        setLoadingPermissions(true);
        try {
            // Step A: Fetch User Specific Overrides (if editing)
            let userOverrides = [];
            if (isEdit && initialData?.UserID) {
                userOverrides = await fetchUserOverrides(initialData.UserID);
            }

            // Step B: Fetch Profile Permissions (New Step)
            // We no longer assume profile object contains permissions, we fetch them explicitly
            const profileDefaultsRaw = await fetchProfilePermissions(fields.ProfileID);
            
            // Save raw profile defaults for visual comparison
            setProfileDefaults(profileDefaultsRaw);

            // Step C: Merge Logic
            const mergedScreens = screens.map(screen => {
                const base = {
                    ScreenID: screen.ScreenID,
                    ScreenName: screen.ScreenName,
                    ScreenCode: screen.ScreenCode,
                    ScreenAccess: false,
                    CanView: false,
                    CanCreate: false,
                    CanEdit: false,
                    CanDelete: false
                };

                // Layer 1: Apply Profile Defaults
                const profilePerm = profileDefaultsRaw.find(pp => pp.ScreenID === screen.ScreenID);
                const withProfile = { ...base, ...profilePerm };

                // Layer 2: Apply User Overrides (if any)
                const userPerm = userOverrides.find(up => up.ScreenID === screen.ScreenID);
                

            if (userPerm) {
                // Normalize user overrides to ensure we don't merge 'null' over 'true'
                const normUserPerm = {
                    ScreenAccess: userPerm.ScreenAccess,
                    CanView: userPerm.CanView,
                    CanCreate: userPerm.CanCreate,
                    CanEdit: userPerm.CanEdit,
                    CanDelete: userPerm.CanDelete
                };

                return {
                    ...withProfile,
                    // FIX: Check for null AND undefined. 
                    // If null or undefined, use profile (withProfile), else use user value.
                    ScreenAccess: (normUserPerm.ScreenAccess !== null && normUserPerm.ScreenAccess !== undefined) 
                                    ? normUserPerm.ScreenAccess : withProfile.ScreenAccess,
                    
                    CanView: (normUserPerm.CanView !== null && normUserPerm.CanView !== undefined) 
                                ? normUserPerm.CanView : withProfile.CanView,
                    
                    CanCreate: (normUserPerm.CanCreate !== null && normUserPerm.CanCreate !== undefined) 
                                ? normUserPerm.CanCreate : withProfile.CanCreate,
                    
                    CanEdit: (normUserPerm.CanEdit !== null && normUserPerm.CanEdit !== undefined) 
                                ? normUserPerm.CanEdit : withProfile.CanEdit,
                    
                    CanDelete: (normUserPerm.CanDelete !== null && normUserPerm.CanDelete !== undefined) 
                                ? normUserPerm.CanDelete : withProfile.CanDelete,
                };
            }

            return withProfile;
            });

            setPermissionScreenList(mergedScreens);
        } catch (error) {
            console.error('Error loading permissions:', error);
        } finally {
            setLoadingPermissions(false);
        }
    };

    const handlePermissionChange = (screenID, field, value) => {
        setPermissionScreenList(prevList =>
            prevList.map(screen => {
                if (screen.ScreenID === screenID) {
                    if (field === 'ScreenAccess' && !value) {
                        return { ...screen, [field]: value, CanView: false, CanCreate: false, CanEdit: false, CanDelete: false };
                    }
                    return { ...screen, [field]: value };
                }
                return screen;
            })
        );
    };

    const handleSavePermissionsOnly = async () => {
        if (!isEdit || !initialData?.UserID) {
            alert('You must create a user before saving permissions.');
            return;
        }
        if (!isUserValid) {
            alert(authError || 'User session invalid.');
            return;
        }

        setIsSavingPermissions(true);
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_URL}/user/${initialData.UserID}/permissions`, {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                },
                body: JSON.stringify({ permissions: permissionScreenList }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to save permissions');
            }

            alert('Permissions saved successfully!');
            await loadPermissionsForUI();
        } catch (error) {
            console.error('Error saving permissions:', error);
            alert(error.message || 'An error occurred while saving permissions');
        } finally {
            setIsSavingPermissions(false);
        }
    };
    // ----------------------------------

    const fetchCurrentUser = async () => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                setIsUserValid(false);
                setAuthError('No token found. Please log in again.');
                return false;
            }
            const userRes = await fetch(`${API_URL}/current-user`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            const userData = await userRes.json();
            
            if (userData.user && userData.user.UserID) {
                setCurrentUser(userData.user);
                setIsUserValid(true);
                setAuthError(null);
                return true;
            } else {
                setIsUserValid(false);
                setAuthError('User information not available. Please log in again.');
                return false;
            }
        } catch (error) {
            console.error('Error fetching current user:', error);
            setIsUserValid(false);
            setAuthError('Error fetching user information. Please refresh page.');
            return false;
        }
    };
    
    const fetchDepartments = async () => {
        setLoadingDepartments(true);
        try {
            const response = await fetch(`${API_URL}/departments`,{headers: getAuthHeaders()});
            const data = await response.json();
            setDepartments(data);
        } catch (error) {
            console.error('Error fetching departments:', error);
            setDepartments([]);
        } finally {
            setLoadingDepartments(false);
        }
    };
    
    const fetchScreenConfig = async () => {
        try {
            const response = await fetch(`${API_URL}/screen-name`,{headers: getAuthHeaders()});
            const data = await response.json();
            const userScreen = data.screens.find(screen => screen.ScreenName.toLowerCase() === 'User'.toLowerCase());
            
            if (userScreen) {
                setScreenConfig(userScreen);
                const shouldShowDepartment = userScreen.ShowOnHeader === true && 
                                          (initialData && (initialData.DepartmentID || initialData.department_id));
                setShowDepartmentField(shouldShowDepartment);
                if (shouldShowDepartment) fetchDepartments();
            }
        } catch (error) {
            console.error('Error fetching screen configuration:', error);
        }
    };
        
    const fetchScreens = async () => {
        try {
            const response = await fetch(`${API_URL}/screen-name`,{headers: getAuthHeaders()});
            const data = await response.json();
            setScreens(data);
        } catch (error) {
            console.error('Error fetching screens:', error);
            setScreens([]);
        }
    };
    
    const fetchProfiles = async () => {
        setLoadingProfiles(true);
        try {
            const response = await fetch(`${API_URL}/role-profiles`,{headers: getAuthHeaders()});
            const data = await response.json();
            setProfiles(data);
            setProfilesFetched(true);
        } catch (error) {
            console.error('Error fetching profiles:', error);
            setProfiles([]);
        } finally {
            setLoadingProfiles(false);
        }
    };


    // Fetch data for a specific screen type
    const fetchFilterData = async (screenName) => {
        const config = FILTER_CONFIG[screenName];
        if (!config) return;
        
        // Cache check - don't fetch if already loaded
        if (filterOptions[screenName]) return;

        try {
            const response = await fetch(`${API_URL}${config.endpoint}`, { headers: getAuthHeaders() });
            const data = await response.json();
            // Handle if data is inside a property (like { screens: [...] }) or direct array
            const list = Array.isArray(data) ? data : (data.screens || data.data || []);
            
            setFilterOptions(prev => ({ ...prev, [screenName]: list }));
        } catch (error) {
            console.error(`Error fetching ${screenName}:`, error);
        }
    };

    // Add a new empty filter row
    const handleAddFilter = () => {
        if (screenFilters.length >= 5) return;
        setScreenFilters(prev => [...prev, { ScreenID: null, ScreenName: '', Values: [] }]);
    };

    // Remove a filter row
    const handleRemoveFilter = (index) => {
        setScreenFilters(prev => prev.filter((_, i) => i !== index));
    };

    // Handle Screen Selection in dropdown
    const handleFilterScreenSelect = (index, screen) => {
        const newFilters = [...screenFilters];
        newFilters[index] = { ScreenID: screen.ScreenID, ScreenName: screen.ScreenName, Values: [] };
        setScreenFilters(newFilters);
        setActiveFilterDropdown(null);
        
        // Fetch the data for this screen
        fetchFilterData(screen.ScreenName);
    };

    // Handle Value Selection (Checkbox)
    const handleFilterValueToggle = (index, valueKey) => {
        const newFilters = [...screenFilters];
        const filter = newFilters[index];
        
        const exists = filter.Values.includes(valueKey);
        if (exists) {
            filter.Values = filter.Values.filter(v => v !== valueKey);
        } else {
            filter.Values.push(valueKey);
        }
        
        setScreenFilters([...newFilters]);
    };

    // Keyboard Navigation for Dropdown
    const handleFilterKeyDown = (e, index) => {
        const screenName = screenFilters[index].ScreenName;
        const options = filterOptions[screenName] || [];
        const config = FILTER_CONFIG[screenName];
        
        if (!config) return;

        // Filter options based on search
        const filteredOptions = options.filter(opt => 
            String(opt[config.labelField1] || '').toLowerCase().includes(filterSearchTerm.toLowerCase()) ||
            String(opt[config.labelField2] || '').toLowerCase().includes(filterSearchTerm.toLowerCase())
        );

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setFocusedOptionIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : prev));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setFocusedOptionIndex(prev => (prev > 0 ? prev - 1 : 0));
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (focusedOptionIndex >= 0 && filteredOptions[focusedOptionIndex]) {
                const item = filteredOptions[focusedOptionIndex];
                const key = item[config.key];
                handleFilterValueToggle(index, key);
            }
        }
    };
    
    const handleProfileSelect = (profileID) => {
        setFields(prev => ({ ...prev, ProfileID: profileID }));
        setProfileDropdownOpen(false);
        setProfileSearchTerm('');
    };
    
    const handleCreateProfile = () => {
        setShowCreateProfileModal(true);
        setProfileDropdownOpen(false);
    };
    
    const handleProfileCreated = async (profileData) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                alert('Authentication token not found. Please log in again.');
                return;
            }
            
            const response = await fetch(`${API_URL}/role-profiles`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(profileData),
            });
            
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to create profile: ${response.status} ${response.statusText} - ${errorText}`);
            }
            
            const result = await response.json();
            const newProfile = result.profile;
            
            await fetchScreens();
            await fetchProfiles();
            
            setFields(prev => ({ ...prev, ProfileID: newProfile.ProfileID }));
            
            setShowCreateProfileModal(false);
            alert('Profile created successfully!');
        } catch (error) {
            console.error('Error creating profile:', error);
            alert(`Error creating profile: ${error.message}`);
        }
    };
        
    const handleProfileUpdated = async (profileData) => {
        try {
            if (!editingProfile || !editingProfile.ProfileID) {
                throw new Error('No profile selected for editing');
            }
            const token = localStorage.getItem('authToken');
            if (!token) {
                alert('Authentication token not found. Please log in again.');
                return;
            }
            
            const response = await fetch(`${API_URL}/role-profiles/${editingProfile.ProfileID}`, {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(profileData),
            });
            
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to update profile: ${response.status} ${response.statusText} - ${errorText}`);
            }
            
            const result = await response.json();
            await fetchScreens();
            await fetchProfiles();
            
            setShowCreateProfileModal(false);
            setEditingProfile(null);
            alert('Profile updated successfully!');
        } catch (error) {
            console.error('Error updating profile:', error);
            alert(`Error updating profile: ${error.message}`);
        }
    };
        
    const handleDeleteProfile = async (profileID) => {
        if (profileID === undefined || profileID === null) return;
        
        if (window.confirm('Are you sure you want to delete this profile? This action cannot be undone.')) {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) {
                    alert('Authentication token not found. Please log in again.');
                    return;
                }
                
                const response = await fetch(`${API_URL}/role-profiles/${profileID}`, {
                    method: 'DELETE',
                    headers: { 
                        'Authorization': `Bearer ${token}`
                    },
                });
                
                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(`Failed to delete profile: ${response.status} ${response.statusText} - ${errorText}`);
                }
                
                setProfiles(prev => prev.filter(profile => profile.ProfileID !== profileID));
                
                if (fields.ProfileID === profileID) {
                    setFields(prev => ({ ...prev, ProfileID: '' }));
                }
                
                alert('Profile deleted successfully!');
            } catch (error) {
                console.error('Error deleting profile:', error);
                alert(`Error deleting profile: ${error.message}`);
            }
        }
    };

    const handleEditProfile = (profile) => {
        if (!profile) return;
        const profileToEdit = {
            ...profile,
            ProfileID: profile.ProfileID || null,
            ProfileCode: profile.ProfileCode || '',
            ProfileName: profile.ProfileName || '',
            Permissions: profile.Permissions || []
        };
        setEditingProfile(profileToEdit);
        setShowCreateProfileModal(true);
        setProfileDropdownOpen(false);
    };
        
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
                setProfileDropdownOpen(false);
            }

            if (activeFilterDropdown && filterDropdownRef.current && !filterDropdownRef.current.contains(event.target)) {
            setActiveFilterDropdown(null);
            setFilterSearchTerm('');
        }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [activeFilterDropdown]);
    
    const toggleMaximize = () => setIsMaximized(!isMaximized);
    
      useEffect(() => {
        if (open) {
            setProfilesFetched(false);
            fetchCurrentUser();
            const hasDepartment = initialData && (initialData.DepartmentID || initialData.department_id);
            setShowDepartmentField(!!hasDepartment);
            if (hasDepartment) fetchDepartments();
            fetchScreens(); 
            
            if (isEdit && initialData) {
                // --- START UPDATE ---
                
                // 1. Define a function to fetch full user details (including filters)
                const fetchFullUserDetails = async () => {
                    try {
                        const response = await fetch(`${API_URL}/user/${initialData.UserID}`, { headers: getAuthHeaders() });
                        const userData = await response.json();

                        // 2. Map fields using the fetched 'userData' instead of 'initialData'
                        const departmentId = userData.DepartmentID || userData.department_id || '';
                        
                        setFields({ 
                            ...initialFields, 
                            ...userData, 
                            Password: '',
                            department_id: departmentId.toString() || '',
                            screen_config: userData.ScreenConfig || '',
                            ProfileID: userData.ProfileID || ''
                        });
                        
                        if (userData.Role === 'Admin') {
                            setActiveTab('userInfo');
                        }

                        // 3. Set Filters using the fetched 'userData'
                        if (userData.screenFilters && Array.isArray(userData.screenFilters)) {
                            const normalizedFilters = userData.screenFilters.map(filter => {
                                return {
                                    ...filter,
                                    ScreenID: filter.ScreenID,
                                    ScreenName: filter.ScreenName,
                                    Values: (filter.Values || []).map(val => {
                                        return typeof val === 'object' && val !== null ? val.value : val;
                                    })
                                };
                            });

                            setScreenFilters(normalizedFilters);

                            // Pre-fetch options for existing filters
                            normalizedFilters.forEach(f => {
                                if(f.ScreenName) fetchFilterData(f.ScreenName);
                            });
                        } else {
                            setScreenFilters([]);
                        }
                    } catch (error) {
                        console.error("Error fetching user details for edit:", error);
                    }
                };

                // 4. Call the fetch function
                fetchFullUserDetails();
                // --- END UPDATE ---

            } else {
                setFields(initialFields);
                setScreenFilters([]);
            }
            setErrors({});
            setIsSubmitting(false);
        } else {
            // Cleanup on close...
            setShowDepartmentField(false);
            setShowProfileField(false);
            setProfilesFetched(false);
            setProfileDropdownOpen(false);
            setProfileSearchTerm('');
            setEditingProfile(null);
            setPermissionScreenList([]);
            setProfileDefaults([]);
            setPermissionSearchTerm('');
            setIsSavingPermissions(false);
            setScreenFilters([]);
        }
    }, [open, initialData, isEdit]);
        
         useEffect(() => {
        // 1. If Role is Admin, always hide Profile field and clear data
        if (fields.Role === 'Admin') {
            setShowProfileField(false);
            setFields(prev => ({ ...prev, ProfileID: '' }));
            if (activeTab === 'permissions') {
                setActiveTab('userInfo');
            }
        } else {
            // 2. If Role is NOT Admin, check if current user is allowed to assign profiles
            if (open && currentUser && ['SubAdmin', 'Admin'].includes(currentUser.Role)) {
               
                // Only fetch if they haven't been fetched yet (Optimization)
                if (!profilesFetched) {
                    fetchProfiles();
                }
               
                // ALWAYS set visibility to true here (Fixing your bug)
                setShowProfileField(true);
            } else {
                // If logged-in user isn't allowed to assign profiles
                setShowProfileField(false);
            }
        }
    }, [open, currentUser, profilesFetched, fields.Role, activeTab]);   // --- UPDATED EFFECT FOR LOADING PERMISSIONS ---
    // Now triggers immediately when ProfileID is selected (like fetchScreens)
    useEffect(() => {
        // Load when a profile is selected, ensuring data is ready for the permission tab
        // Also skip loading if Role is Admin
        if (fields.ProfileID && profiles.length > 0 && fields.Role !== 'Admin') {
            loadPermissionsForUI();
        } else if (!fields.ProfileID || fields.Role === 'Admin') {
            setPermissionScreenList([]);
            setProfileDefaults([]);
        }
    }, [fields.ProfileID, profiles, isEdit, fields.Role]); 
    // ----------------------------------------

    useEffect(() => {
        if (activeTab === 'permissions') setPermissionTabActive(true);
    }, [activeTab]);
    // ----------------------------------------

    const handleChange = e => {
        const { name, value } = e.target;
        setFields(prev => ({ ...prev, [name]: value }));
    };
    
    const validate = () => {
        const errs = {};
        if (!fields.Username) errs.Username = 'Required';
        if (!fields.FullName) errs.FullName = 'Required';
        if (!fields.Email) errs.Email = 'Required';
        if (!fields.Role) errs.Role = 'Required';
        if (!isEdit && !fields.Password) errs.Password = 'Required';
        
        if (showDepartmentField && !fields.department_id) errs.department_id = 'Department is required';
       // If Role is Admin, Profile is not required. For other roles, it is required.
        if (showProfileField && fields.Role !== 'Admin' && !fields.ProfileID) errs.ProfileID = 'Profile is required';
        
        setErrors(errs);
        return Object.keys(errs).length === 0;
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        if (!validate()) return;
        
        if (!isUserValid || !currentUser || !currentUser.UserID) {
            alert(authError || 'User information not available. Please refresh page and log in again.');
            return;
        }
        
        setIsSubmitting(true);
        const formData = { ...fields };
        // Only include permissions if not Admin
        if (fields.Role !== 'Admin') {
            formData.permissions = permissionScreenList;
        } else {
            formData.permissions = []; // Explicitly empty for Admins
        }

         formData.screenFilters = screenFilters;

        if (isEdit) {
            delete formData.Password;
            formData.updated_by = parseInt(currentUser.UserID);
        } else {
            formData.created_by = parseInt(currentUser.UserID);
        }
        
        if (showDepartmentField && formData.department_id) {
            formData.department_id = formData.department_id;
        } else {
            delete formData.department_id;
        }
        
        try {
            let response;
            if (isEdit && initialData) {
                response = await fetch(`${API_URL}/user/${initialData.UserID}`, {
                    method: 'PUT',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(formData),
                });
            } else {
                response = await fetch(`${API_URL}/user`, {
                    method: 'POST',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(formData),
                });
            }
            
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || `Failed to ${isEdit ? 'update' : 'create'} user`);
            }
            
            onSubmit(formData, isEdit);
            onClose();
        } catch (error) {
            console.error('Error saving user:', error);
            alert(error.message || 'An error occurred while saving the user');
        } finally {
            setIsSubmitting(false);
        }
    };
        
    const tabs = [
        { id: 'userInfo', name: 'User Info' },
        { id: 'permissions', name: 'Permissions' },
         { id: 'filters', name: 'Data Filters' },
    ];

    // Filter tabs based on Role
    const visibleTabs = fields.Role === 'Admin'
        ? tabs.filter(t => t.id !== 'permissions' && t.id !== 'filters')
        : tabs;
        
    const filteredProfiles = profiles.filter(profile => {
        if (!profile) return false;
        const profileName = profile.ProfileName || '';
        const profileCode = profile.ProfileCode || '';
        const searchTerm = profileSearchTerm.toLowerCase();
        return (
            profileName.toLowerCase().includes(searchTerm) ||
            profileCode.toLowerCase().includes(searchTerm)
        );
    });
        
    const selectedProfile = profiles.find(p => p && p.ProfileID === parseInt(fields.ProfileID));
    const selectedProfileName = selectedProfile ? `${selectedProfile.ProfileCode || ''} - ${selectedProfile.ProfileName || ''}` : '';

    const isOverridden = (screenID, field, currentValue) => {
        const profilePerm = profileDefaults.find(p => p.ScreenID === screenID);
        if (!profilePerm) return false; 
        
        const profileValue = profilePerm[field];
        return (profileValue !== currentValue);
    };
        
    return (
        <>
            <div className={`fixed inset-0 z-50 flex justify-center transition-all duration-300 ease-in-out ${open ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                <style>{`
                    .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                    .hide-scrollbar::-webkit-scrollbar { display: none; }
                    .custom-scrollbar::-webkit-scrollbar { height: 8px; }
                    .custom-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 10px; }
                    .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
                    .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
                    .uppercase-input { text-transform: uppercase; }
                    .profile-dropdown { max-height: 300px; overflow-y: auto; }
                    .profile-item { display: flex; justify-content: space-between; align-items: center; }
                    .profile-item:hover { background-color: #f9fafb; }
                    .profile-actions { display: flex; gap: 8px; }
                    .checkbox-overridden { accent-color: #2563eb; opacity: 1; font-weight: bold; }
                    .checkbox-inherited { accent-color: #9ca3af; opacity: 0.6; }
                `}</style>
                <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
                <div className={`bg-white shadow-2xl ${isMaximized ? 'w-full h-full' : 'w-full max-w-6xl h-full'} flex flex-col transition-transform transform-gpu duration-300 ease-in-out ${open ? 'translate-x-0' : 'translate-x-full'}`}>
                    <div className="flex-shrink-0 p-8 pb-6">
                        <div className="flex justify-between items-center">
                            <h2 className="text-2xl font-bold text-[#384959]">{isEdit ? 'Edit User' : 'Create New User'}</h2>
                            <div className="flex items-center gap-3">
                                <button className="text-[#A0AEC0] hover:text-[#384959] transition-colors" onClick={toggleMaximize}>
                                    {isMaximized ? <MinimizeIcon size={24} /> : <MaximizeIcon size={24} />}
                                </button>
                                <button className="text-[#A0AEC0] hover:text-[#384959] transition-colors" onClick={onClose}>
                                    <CloseIcon size={24} />
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    {open && !isUserValid && (
                        <div className="mx-8 mb-4 bg-red-50 border-l-4 border-red-500 p-4">
                            <p className="text-sm text-red-700">{authError || 'User information not available.'}</p>
                        </div>
                    )}
                    
                    <div className="flex-shrink-0 px-8 pb-6">
                        <div className="flex border-b border-[#BDDDFC] -mx-8 px-8 overflow-x-auto overflow-y-hidden whitespace-nowrap custom-scrollbar">
                            {visibleTabs.map(tab => (
                                <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`pb-4 px-4 -mb-px text-sm font-medium transition-colors focus:outline-none ${activeTab === tab.id ? 'border-b-2 border-[#6A89A7] text-[#6A89A7]' : 'border-b-2 border-transparent text-[#A0AEC0] hover:text-[#6A89A7]'}`}>
                                    {tab.name}
                                </button>
                            ))}
                        </div>
                    </div>
                    
                    <div className="flex-grow overflow-y-auto hide-scrollbar px-8">
                        <form onSubmit={handleSubmit} className="space-y-6 pb-6">
                            <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
                                {activeTab === 'userInfo' && (
                                    <div className='space-y-4'>
                                        <h3 className="text-lg font-semibold text-[#384959] mb-4">User Information</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div className='flex flex-col gap-2'>
                                                <label className="block text-sm font-medium text-[#64748b]">Username <span className='text-red-600'>*</span></label>
                                                <input name="Username" autoComplete="off" value={fields.Username} onChange={handleChange} className={`w-full border rounded-lg px-3 py-2 uppercase-input ${errors.Username ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]`} />
                                                {errors.Username && <span className="text-xs text-red-500">{errors.Username}</span>}
                                            </div>
                                            <div className='flex flex-col gap-2'>
                                                <label className="block text-sm font-medium text-[#64748b]">Full Name <span className='text-red-600'>*</span></label>
                                                <input name="FullName" autoComplete="off" value={fields.FullName} onChange={handleChange} className={`w-full border rounded-lg px-3 py-2 uppercase-input ${errors.FullName ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]`} />
                                                {errors.FullName && <span className="text-xs text-red-500">{errors.FullName}</span>}
                                            </div>
                                            <div className='flex flex-col gap-2'>
                                                <label className="block text-sm font-medium text-[#64748b]">Email <span className='text-red-600'>*</span></label>
                                                <input name="Email" autoComplete="off" value={fields.Email} onChange={handleChange} className={`w-full border rounded-lg px-3 py-2 ${errors.Email ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]`} />
                                                {errors.Email && <span className="text-xs text-red-500">{errors.Email}</span>}
                                            </div>
                                            <div className='flex flex-col gap-2'>
                                                <label className="block text-sm font-medium text-[#64748b]">Phone</label>
                                                <input name="Phone" autoComplete="off" value={fields.Phone} onChange={handleChange} className="w-full border border-[#E2E8F0] rounded-lg px-3 py-2 uppercase-input focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]" />
                                            </div>
                                            <div className='flex flex-col gap-2'>
                                                <label className="block text-sm font-medium text-[#64748b]">Role <span className='text-red-600'>*</span></label>
                                                <select name="Role" value={fields.Role} onChange={handleChange} className={`w-full border rounded-lg px-3 py-2 ${errors.Role ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]`}>
                                                    <option value="Admin">Admin</option>
                                                    <option value="SubAdmin">SubAdmin</option>
                                                    <option value="User">User</option>
                                                    
                                                </select>
                                                {errors.Role && <span className="text-xs text-red-500">{errors.Role}</span>}
                                            </div>

                                            {showProfileField && (
                                                <div className='flex flex-col gap-2'>
                                                    <label className="block text-sm font-medium text-[#64748b]">Profile <span className='text-red-600'>*</span></label>
                                                    <div className="relative" ref={profileDropdownRef}>
                                                        <div className={`w-full border rounded-lg px-3 py-2 flex justify-between items-center cursor-pointer ${errors.ProfileID ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]`} onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}>
                                                            <span className={selectedProfileName ? '' : 'text-gray-400'}>{selectedProfileName || 'Select Profile'}</span>
                                                            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                                                        </div>
                                                        {profileDropdownOpen && (
                                                            <div className="absolute z-10 w-full mt-1 bg-white border border-[#E2E8F0] rounded-lg shadow-lg profile-dropdown">
                                                                <div className="p-2 border-b border-[#E2E8F0]">
                                                                    <input type="text" placeholder="Search profiles..." className="w-full px-3 py-2 border border-[#E2E8F0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]" value={profileSearchTerm} onChange={(e) => setProfileSearchTerm(e.target.value)} />
                                                                </div>
                                                                <div className="max-h-60 overflow-y-auto">
                                                                    {filteredProfiles.length > 0 ? filteredProfiles.map(profile => (
                                                                        <div key={profile.ProfileID} className="profile-item px-3 py-2">
                                                                            <div className="flex-grow cursor-pointer" onClick={() => handleProfileSelect(profile.ProfileID)}>{profile.ProfileCode} - {profile.ProfileName}</div>
                                                                            <div className="profile-actions">
                                                                                <button type="button" className="text-blue-500 hover:text-blue-700" onClick={(e) => { e.stopPropagation(); handleEditProfile(profile); }}><EditIcon /></button>
                                                                                <button type="button" className="text-red-500 hover:text-red-700" onClick={(e) => { e.stopPropagation(); handleDeleteProfile(profile.ProfileID); }}><TrashIcon /></button>
                                                                            </div>
                                                                        </div>
                                                                    )) : <div className="px-4 py-2 text-gray-500 text-center">No profiles found</div>}
                                                                </div>
                                                                <div className="p-2 border-t border-[#E2E8F0]">
                                                                    <button type="button" className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-[#6A89A7] text-white rounded-lg hover:bg-[#88BDF2] transition-colors" onClick={handleCreateProfile}><PlusIcon /> Create New Profile</button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {errors.ProfileID && <span className="text-xs text-red-500">{errors.ProfileID}</span>}
                                                </div>
                                            )}
                                            
                                            {showDepartmentField && (
                                                <div className='flex flex-col gap-2'>
                                                    <label className="block text-sm font-medium text-[#64748b]">Department *</label>
                                                    <select name="department_id" value={fields.department_id || ''} onChange={handleChange} className={`w-full border rounded-lg px-3 py-2 ${errors.department_id ? 'border-red-400' : 'border-[#E2E8F0]'} focus:outline-none focus:ring-2 focus:ring-[#BDDDFC] uppercase`} disabled={loadingDepartments}>
                                                        <option value="">{loadingDepartments ? 'Loading...' : 'Select Department'}</option>
                                                        {departments.map((dept) => <option key={dept.DepartmentID} value={dept.DepartmentID}>{dept.DepartmentCode} - {dept.DepartmentName}</option>)}
                                                    </select>
                                                    {errors.department_id && <span className="text-xs text-red-500">{errors.department_id}</span>}
                                                </div>
                                            )}
                                            
                                            <div className='flex flex-col gap-2'>
                                                <label className="block text-sm font-medium text-[#64748b]">Status <span className='text-red-600'>*</span></label>
                                                <select name="IsActive" value={fields.IsActive} onChange={handleChange} className="w-full border border-[#E2E8F0] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#BDDDFC]">
                                                    <option value={1}>Active</option>
                                                    <option value={0}>Inactive</option>
                                                </select>
                                            </div>
                                            
                                            {!isEdit && (
                                                <div className='flex flex-col gap-2'>
                                                    <label className="block text-sm font-medium text-[#64748b]">Password <span className='text-red-600'>*</span></label>
                                                    <div className={`relative w-full border rounded-lg ${errors.Password ? 'border-red-400' : 'border-[#E2E8F0]'}`}>
                                                        <input name="Password" type={showPassword ? 'text' : 'password'} autoComplete="new-password" value={fields.Password} onChange={handleChange} className="w-full pr-10 px-3 py-2 bg-transparent outline-none" />
                                                        <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center text-[#A0AEC0] hover:text-[#64748b]" onClick={() => setShowPassword(v => !v)}>{showPassword ? <EyeSlashIcon /> : <EyeIcon />}</button>
                                                    </div>
                                                    {errors.Password && <span className="text-xs text-red-500">{errors.Password}</span>}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'permissions' && (
                                    <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
                                        <div className="flex justify-between items-center mb-2">
                                            <div>
                                                <h3 className="text-lg font-semibold text-[#384959]">Screen Access & Overrides</h3>
                                                <p className="text-sm text-gray-500">Managing for "<strong>{selectedProfileName || 'Selected Profile'}</strong>".</p>
                                            </div>
                                            {isEdit && (
                <button type="button" onClick={handleSavePermissionsOnly} disabled={isSavingPermissions} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-white font-semibold shadow transition-all ${isSavingPermissions ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#6A89A7] hover:bg-[#88BDF2]'} disabled:opacity-50`}>
                    <SaveIcon size={16} /> {isSavingPermissions ? 'Saving...' : 'Save Permissions'}
                </button>
            )}
                                        </div>
                                        <div className="mb-4 text-xs text-gray-500">
                                            <span className="font-bold text-blue-600">Blue checkboxes</span> indicate custom overrides. 
                                            <span className="font-bold text-gray-500"> Gray checkboxes</span> indicate profile defaults.
                                        </div>
                                        <div className="mb-4 relative max-w-sm">
                                            <input type="text" placeholder="Search screens..." className="w-full pl-8 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value={permissionSearchTerm} onChange={(e) => setPermissionSearchTerm(e.target.value)} />
                                            <SearchIcon className="absolute left-2.5 top-2.5 text-gray-400" />
                                        </div>
                                        {loadingPermissions ? <div className="text-center py-4">Loading permissions...</div> : (
                                            <div className="overflow-x-auto">
                                                <table className="min-w-full divide-y divide-gray-200 border border-gray-200">
                                                    <thead className="bg-gray-50">
                                                        <tr>
                                                            <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase">Screen Name</th>
                                                            <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase">Profile Default</th>
                                                            <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase">User Access</th>
                                                            <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase">View</th>
                                                            <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase">Create</th>
                                                            <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase">Edit</th>
                                                            <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase">Delete</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="bg-white divide-y divide-gray-200">
                                                        {permissionScreenList.filter(screen => screen.ScreenName.toLowerCase().includes(permissionSearchTerm.toLowerCase())).map((screen) => {
                                                            const profilePerm = profileDefaults.find(p => p.ScreenID === screen.ScreenID);
                                                            const profileAccess = profilePerm ? profilePerm.ScreenAccess : false;
                                                            return (
                                                                <tr key={screen.ScreenID} className="hover:bg-gray-50">
                                                                    <td className="px-2 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{screen.ScreenName}</td>
                                                                    <td className="px-2 py-3 whitespace-nowrap text-center">
                                                                        <div className={`inline-flex justify-center items-center w-5 h-5 rounded border ${profileAccess ? 'bg-green-100 border-green-300 text-green-600' : 'bg-gray-100 border-gray-300 text-gray-400'}`}>{profileAccess ? '✓' : '-'}</div>
                                                                    </td>
                                                                    <td className="px-2 py-3 whitespace-nowrap text-center">
                                                                        <input type="checkbox" checked={screen.ScreenAccess} onChange={(e) => handlePermissionChange(screen.ScreenID, 'ScreenAccess', e.target.checked)} className={`h-4 w-4 cursor-pointer ${isOverridden(screen.ScreenID, 'ScreenAccess', screen.ScreenAccess) ? 'checkbox-overridden' : 'checkbox-inherited'}`} />
                                                                    </td>
                                                                    {['CanView', 'CanCreate', 'CanEdit', 'CanDelete'].map(perm => (
                                                                        <td key={perm} className="px-2 py-3 whitespace-nowrap text-center">
                                                                            <input type="checkbox" checked={screen[perm]} onChange={(e) => handlePermissionChange(screen.ScreenID, perm, e.target.checked)} className={`h-4 w-4 cursor-pointer ${isOverridden(screen.ScreenID, perm, screen[perm]) ? 'checkbox-overridden' : 'checkbox-inherited'}`} disabled={!screen.ScreenAccess} />
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                )}


                                                                {activeTab === 'filters' && (
                                    <div className="bg-[#F9FAFB] rounded-xl p-6 border border-[#E2E8F0]">
                                        <div className="flex justify-between items-center mb-4">
                                            <div>
                                                <h3 className="text-lg font-semibold text-[#384959]">Data Access Filters</h3>
                                                <p className="text-sm text-gray-500">Limit user visibility to specific data (Max 5).</p>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={handleAddFilter}
                                                disabled={screenFilters.length >= 5}
                                                className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-white text-sm font-medium ${screenFilters.length >= 5 ? 'bg-gray-300 cursor-not-allowed' : 'bg-[#6A89A7] hover:bg-[#88BDF2]'}`}
                                            >
                                                <PlusIcon size={14} /> Add Filter
                                            </button>
                                        </div>

                                        {screenFilters.length === 0 && (
                                            <div className="text-center py-8 text-gray-400 border-2 border-dashed rounded-lg">
                                                No filters applied. User will see all data based on permissions.
                                            </div>
                                        )}

                                        <div className="space-y-4">
                                            {screenFilters.map((filter, index) => {
                                                const config = FILTER_CONFIG[filter.ScreenName];
                                                const options = filterOptions[filter.ScreenName] || [];
                                                
                                                return (
                                                    <div key={index} className="flex gap-4 items-start bg-white p-4 border rounded-lg shadow-sm">
                                                        {/* Column 1: Screen Selection */}
                                                        <div className="w-1/3 relative"
                                                        ref={activeFilterDropdown === `screen_${index}` ? filterDropdownRef : null} >
                                                            <label className="block text-xs font-medium text-gray-500 mb-1">Screen</label>
                                                            <div 
                                                                className="w-full border rounded p-2 cursor-pointer flex justify-between items-center bg-gray-50"
                                                                onClick={() => setActiveFilterDropdown(activeFilterDropdown === `screen_${index}` ? null : `screen_${index}`)}
                                                            >
                                                                <span className={filter.ScreenName ? 'text-gray-800' : 'text-gray-400'}>
                                                                    {filter.ScreenName === 'WAREHOUSE' ? 'Location' : (filter.ScreenName || 'Select Screen')}
                                                                </span>
                                                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                                                            </div>
                                                            
                                                            {activeFilterDropdown === `screen_${index}` && (
                                                                <div className="absolute z-20 mt-1 w-full bg-white border shadow-lg rounded-md max-h-60 overflow-y-auto">
                                                                    {screens
                                                                        .filter(s => 
                                                                            FILTER_CONFIG[s.ScreenName] && // Only show allowed screens
                                                                            !screenFilters.some(f => f.ScreenID === s.ScreenID && f !== filter) // Exclude already selected
                                                                        )
                                                                        .map(s => (
                                                                            <div
                                                                                key={s.ScreenID}
                                                                                className="p-2 hover:bg-blue-50 cursor-pointer text-sm"
                                                                                onClick={() => handleFilterScreenSelect(index, s)}
                                                                            >
                                                                                {s.ScreenName === 'WAREHOUSE' ? 'Location' : s.ScreenName}
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Column 2: Values Multi-Select */}
                                                        <div className="flex-1 relative"
                                                        ref={activeFilterDropdown === `value_${index}` ? filterDropdownRef : null} >
                                                            <label className="block text-xs font-medium text-gray-500 mb-1">Values (IDs)</label>
                                                            
                                                            {/* Display Selected Tags */}
                                                            <div className="flex flex-wrap gap-1 mb-1 min-h-[24px]">
                                                                {filter.Values.map(val => (
                                                                    <span key={val} className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded text-xs flex items-center gap-1">
                                                                        {val}
                                                                        <button type="button" onClick={() => handleFilterValueToggle(index, val)} className="font-bold hover:text-red-600">×</button>
                                                                    </span>
                                                                ))}
                                                            </div>

                                                            {/* Search Input */}
                                                            <input
                                                                type="text"
                                                                placeholder="Search to select..."
                                                                className="w-full border rounded p-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                value={activeFilterDropdown === `value_${index}` ? filterSearchTerm : ''}
                                                                onChange={(e) => { setActiveFilterDropdown(`value_${index}`); setFilterSearchTerm(e.target.value); setFocusedOptionIndex(-1); }}
                                                                onFocus={() => { setActiveFilterDropdown(`value_${index}`); setFilterSearchTerm(''); }}
                                                                onKeyDown={(e) => handleFilterKeyDown(e, index)}
                                                            />

                                                            {/* Dropdown List */}
                                                            {activeFilterDropdown === `value_${index}` && (
                                                                <div className="absolute z-20 mt-1 w-full bg-white border shadow-lg rounded-md max-h-48 overflow-y-auto">
                                                                    {options.length === 0 ? (
                                                                        <div className="p-3 text-gray-400 text-sm">Loading...</div>
                                                                    ) : (
                                                                        options
                                                                            .filter(opt => 
                                                                                String(opt[config?.labelField1] || '').toLowerCase().includes(filterSearchTerm.toLowerCase()) ||
                                                                                String(opt[config?.labelField2] || '').toLowerCase().includes(filterSearchTerm.toLowerCase())
                                                                            )
                                                                            .map((opt, i) => {
                                                                                const key = opt[config.key];
                                                                                const isChecked = filter.Values.includes(key);
                                                                                
                                                                                // LOGIC: Check if it is a Feeder screen AND has no Parent
                                                                                const isMainFeeder = filter.ScreenName === 'Feeder' && !opt.ParentSiteCode;

                                                                                return (
                                                                                    <div
                                                                                        key={key}
                                                                                        className={`p-2 cursor-pointer text-sm flex items-center gap-2 
                                                                                            ${focusedOptionIndex === i ? 'bg-blue-100' : 'hover:bg-gray-50'} 
                                                                                            ${isMainFeeder ? 'text-red-600 font-semibold bg-red-50' : ''}`}
                                                                                        onClick={() => handleFilterValueToggle(index, key)}
                                                                                    >
                                                                                        <input type="checkbox" checked={isChecked} onChange={() => {}} className="pointer-events-none" />
                                                                                        {/* Applied red color specifically to text if it is a main feeder */}
                                                                                        <span className={`font-medium ${isMainFeeder ? 'text-red-600' : ''}`}>
                                                                                            {opt[config.labelField1]}
                                                                                        </span>
                                                                                        <span className={`truncate ${isMainFeeder ? 'text-red-500' : 'text-gray-500'}`}>
                                                                                            - {opt[config.labelField2]}
                                                                                        </span>
                                                                                        
                                                                                        {/* Optional: Add a small badge to identify it easily */}
                                                                                        {isMainFeeder && (
                                                                                            <span className="ml-auto text-xs bg-red-100 text-red-700 px-1.5 py-0.5 rounded">
                                                                                                Main
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Remove Button */}
                                                        <div className="pt-5">
                                                            <button type="button" onClick={() => handleRemoveFilter(index)} className="text-red-400 hover:text-red-600 p-1">
                                                                <TrashIcon size={18} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="flex justify-end gap-3">
                                <button type="button" className="px-6 py-3 rounded-lg text-[#64748b] font-semibold hover:bg-[#F1F5F9]" onClick={onClose}>Cancel</button>
                                <button type="submit" className="px-6 py-3 rounded-lg text-white font-semibold shadow-lg hover:scale-105 bg-[#6A89A7] hover:bg-[#88BDF2] disabled:opacity-50 disabled:cursor-not-allowed transition-all" disabled={loading || isSubmitting || !isUserValid}>{loading || isSubmitting ? 'Saving...' : (isEdit ? 'Update & Save' : 'Continue & Save')}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
            {showCreateProfileModal && (
                <ProfileFormModal
                    key={`${editingProfile?.ProfileID || 'new'}-${screens.length}`}
                    open={showCreateProfileModal}
                    onClose={() => { setShowCreateProfileModal(false); setEditingProfile(null); }}
                    onSubmit={editingProfile ? handleProfileUpdated : handleProfileCreated}
                    initialData={editingProfile}
                    screens={screens}
                />
            )}
        </>
    );
};

export default UserFormModal;